import { createContext, useState, useEffect, useContext, useCallback } from 'react';
import axios from "axios";
import Cookies from "js-cookie"
import { jwtDecode } from 'jwt-decode'; // ✅ Správně

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

const AuthProvider = ({ children }) => {

  //QUEST 
  const [quest, setQuest] = useState(null)
  const [isQuestAuthenticated, setIsQuestAuthenticated] = useState(false)

    useEffect(() => {
      const savedQuest = Cookies.get("questData");
      if (savedQuest) {
        try {
          setQuest(JSON.parse(savedQuest));
        } catch (error) {
          console.error("Chyba při parsování questData:", error);
        }
      }
    }, []);

    useEffect(() => {
      if (quest) {
        setIsQuestAuthenticated(true);
      }
    }, [quest]);
  
  // USER
  const [user, setUser] = useState(null);
  const [userToken, setUserToken] = useState(localStorage.getItem("userToken"));

  useEffect(() => {
    if (userToken) {
      const fetchProfile = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/users/profile`, {
            headers: {
              "Authorization": `Bearer ${userToken}`,
            }
          });
          setUser(response.data);
        } catch (err) {
          localStorage.removeItem("userToken")
        }
      };
      fetchProfile();
    } else {
      // Uživatelský profil není dostupný, pokud není token
      setUser(null);
    }
  }, [userToken]);

  useEffect(() => {
    if (userToken) {
      localStorage.setItem("userToken", userToken);
    } else {
      localStorage.removeItem("userToken");
    }
  }, [userToken]);


  const logout = () => {
    localStorage.removeItem("userToken");
    setUserToken(null);
    setUser(null);
  };

  const login = (token) => {
    localStorage.setItem('userToken', token);
    setUserToken(token);
    Cookies.remove("questData")
    localStorage.removeItem("businessToken");
  };

  // BUSINESS
  const [business, setBusiness] = useState(null);
  const [businessToken, setBusinessToken] = useState(localStorage.getItem("businessToken"));
  const [businessAdminToken, setBusinessAdminToken] = useState(localStorage.getItem("businessAdminToken"));
  const [profileWorkHours, setProfileWorkHours] = useState([])
  const [adminBusiness, setAdminBusiness] = useState(null);



  const fetchBusinessAdmin = useCallback(async () => {
    if (businessAdminToken) {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/business/admin-profile`, {
          headers: {
            Authorization: `Bearer ${businessAdminToken}`
          }
        });
        setAdminBusiness(response.data);
      } catch (err) {
        console.error(err.response?.data?.message);
      }
    }
  }, [businessAdminToken]);

  useEffect(() => {
    fetchBusinessAdmin()
  },[fetchBusinessAdmin, businessAdminToken])


  const fetchBusiness = useCallback(async() => {
    try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/business/profile`, {
      headers: {
        "Authorization": `Bearer ${businessToken}`
        }
      }
    )
    setBusiness(response.data)

    } catch (err) {
      console.log(err.response?.data?.message)
    }
  },[businessToken])

  useEffect(() => {
    if (businessToken) {
      const fetchBusinessProfile = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/business/profile`, {
            headers: {
              "Authorization": `Bearer ${businessToken}`,
            }
          });
          setBusiness(response.data);
          setProfileWorkHours(response.data.workHours)
        } catch (err) {
          if (businessAdminToken) {
            console.log("Prihlaseny je admin")
          } else {
            localStorage.removeItem("businessToken")
          }
          
        }
      };
      fetchBusinessProfile();
    } else {
      setBusiness(null);
    }
  }, [businessToken, businessAdminToken]);

  useEffect(() => {
    if (businessToken) {
      localStorage.setItem("businessToken", businessToken);
    } else {
      localStorage.removeItem("businessToken");
    }
  }, [businessToken]);
  
  useEffect(() => {
    if (businessAdminToken) {
      localStorage.setItem("businessAdminToken", businessAdminToken);
    } else {
      localStorage.removeItem("businessAdminToken");
    }
  }, [businessAdminToken]);

  const businessLogin = (token) => {
    const decodedToken = jwtDecode(token);
  
    if (decodedToken.type === 'business') {
      setBusinessToken(token);
      localStorage.setItem('businessToken', token);
      setBusinessAdminToken(null);
      localStorage.removeItem('businessAdminToken');
    } else if (decodedToken.type === 'admin') {
      setBusinessAdminToken(token);
      localStorage.setItem('businessAdminToken', token);
      setBusinessToken(null);
      localStorage.removeItem('businessToken');
    }
  
    setUser(null);
    setUserToken(null);
    localStorage.removeItem("userToken");
    Cookies.remove("questData");
  };

  const businessLogout = () => {
    setBusiness(null);
    setBusinessToken(null);
    localStorage.removeItem("businessToken");
  
    setAdminBusiness(null);
    setBusinessAdminToken(null);
    localStorage.removeItem("businessAdminToken");
  
    window.location.reload(); // nebo navigate('/')
  };


  //Rezervace
  const [reservation, setReservation] = useState([])
  const [todayReservation, setTodayReservation] = useState([])
  const [futureReservation, setFutureReservation] = useState([])
  const [historyReservation, setHistoryReservation] = useState([])

    const fetchReservationList = useCallback(async () => {
      if (business && businessToken) {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/reservation/list`, {
            params: {businessId: business._id}
          })
          setReservation(response.data.reservation)
          setTodayReservation(() => {
            const reservations = response.data.reservation
            const currentDate = new Date()
            currentDate.setHours(0,0,0,0)

            const today = reservations.filter((reservation) => {
              const resDate = new Date(reservation.date)
              resDate.setHours(0,0,0,0)
              return resDate.getTime() === currentDate.getTime()
            })
            return today 
          })
          setFutureReservation(() => {
            const reservations = response.data.reservation
            const currentDate = new Date()
            currentDate.setHours(0,0,0,0)

            const future = reservations.filter((reservation) => {
              const resDate = new Date(reservation.date)
              resDate.setHours(0,0,0,0)
              return resDate.getTime() > currentDate.getTime()
            })
            return future
          })
          setHistoryReservation(() => {
            const reservations = response.data.reservation
            const currentDate = new Date() 
            currentDate.setHours(0,0,0,0)

            const history = reservations.filter((reservation) => {
              const resDate = new Date(reservation.date)
              resDate.setHours(0,0,0,0)
              return resDate.getTime() < currentDate.getTime()
            })
            return history
          })
        } catch (err) {
          console.error(err.response?.data?.message || err.message)
        }
      }
    }, [business, businessToken, setFutureReservation, setHistoryReservation, setTodayReservation])

    useEffect(() => {
      if (business && businessToken) {
        fetchReservationList()
      }
    }, [fetchReservationList, business, businessToken])
 
    //hotelReservation
    const [upcomingHotelReservations, setUpcomingHotelReservations] = useState([]);
    const [historyHotelReservations, setHistoryHotelReservations] = useState([]);
    const [hotelMessage, setHotelMessage] = useState(null)
    

    useEffect(() => {
      const fetchList = async () => {
          try {
              const response = await axios.get(`${process.env.REACT_APP_API_URL}/booking/list`, {
                  params: { businessId: business._id },
                  headers: { Authorization: `Bearer ${businessToken}` },
              });
              const today = new Date();
              const upcoming = [];
              const history = [];
              
              response.data.reservations.forEach(reservation => {
                  reservation.reservations.forEach(oneReservation => {
                      const checkOutDate = new Date(oneReservation.checkOutDate);
                      if (checkOutDate >= today) {
                          upcoming.push(oneReservation);
                      } else {
                          history.push(oneReservation);
                      }
                  });
              });
              
              // Seřazení podle checkInDate
              const sortedUpcoming = upcoming.sort((a, b) => new Date(a.checkInDate) - new Date(b.checkInDate));
              const sortedHistory = history.sort((a, b) => new Date(a.checkInDate) - new Date(b.checkInDate));
  
              setUpcomingHotelReservations(sortedUpcoming);
              setHistoryHotelReservations(sortedHistory);
  
          } catch (err) {
              console.log(err.response?.data?.message || "Chyba při načítání" );
          }
      };
  
      if (business && businessToken) {
          fetchList();
      }
  }, [business, businessToken]);

  const fetchList = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/booking/list`, {
            params: { businessId: business._id },
            headers: { Authorization: `Bearer ${businessToken}` },
        });
        const today = new Date();
        const upcoming = [];
        const history = [];
        
        response.data.reservations.forEach(reservation => {
            reservation.reservations.forEach(oneReservation => {
                const checkOutDate = new Date(oneReservation.checkOutDate);
                if (checkOutDate >= today) {
                    upcoming.push(oneReservation);
                } else {
                    history.push(oneReservation);
                }
            });
        });
        
        // Seřazení podle checkInDate
        const sortedUpcoming = upcoming.sort((a, b) => new Date(a.checkInDate) - new Date(b.checkInDate));
        const sortedHistory = history.sort((a, b) => new Date(a.checkInDate) - new Date(b.checkInDate));

        setUpcomingHotelReservations(sortedUpcoming);
        setHistoryHotelReservations(sortedHistory);

    } catch (err) {
        console.log(err.response?.data?.message || "Chyba při načítání" );
    }
};

        const handleHotelReservationConfirm = async (reservationId) => {
                try {
                    const response = await axios.put(
                        `${process.env.REACT_APP_API_URL}/booking/confirm/${reservationId}`,
                        { business: business._id },
                        { headers: { Authorization: `Bearer ${businessToken}` } }
                    );
                    
                    console.log(response.data.message || "hotovo")
                } catch (err) {
                    setHotelMessage((prev) => ({ ...prev, [reservationId]: err.response?.data?.message || "Chyba při potvrzení." }));
                } finally {
                    fetchList()
                }
            };
        
            const handleHotelReservationCancel = async (reservationId) => {
                try {
                    const response = await axios.delete(
                        `${process.env.REACT_APP_API_URL}/booking/cancel/${reservationId}?business=${business._id}`,
                        { headers: { Authorization: `Bearer ${businessToken}` } }
                    );
                    
                  setHotelMessage((prev) => ({ ...prev, [reservationId]:response.data.message}) || "hotovo")
                } catch (err) {
                  setHotelMessage((prev) => ({ ...prev, [reservationId]: err.response?.data?.message || "Chyba při zrušení." }));
                } finally {
                  setTimeout(() => {
                    fetchList()
                  }, 2000)
                    

                }
            };
        


        //Basic reservation
        const [historyBasicReservations, setHistoryBasicReservations] = useState([]);
        const [todayBasicReservations, setTodayBasicReservations] = useState([]);
        const [upcomingBasicReservations, setUpcomingBasicReservations] = useState([]);
        const [basicMessage, setBasicMessage] = useState(null);
        
        useEffect(() => {
            const fetchBasicReservation = async () => {
                if (!business?._id || !businessToken) return;
        
                try {
                    const response = await axios.get(
                        `${process.env.REACT_APP_API_URL}/basic-reservation/list`,
                        {
                            params: { businessId: business._id },
                            headers: { Authorization: `Bearer ${businessToken}` },
                        }
                    );
        
                    const now = new Date();
        
                    // Rozdělení rezervací podle data
                    const history = response.data.reservation.filter(res => new Date(res.date) < now);
                    const today = response.data.reservation.filter(res => new Date(res.date).toDateString() === now.toDateString());
                    const upcoming = response.data.reservation.filter(res => new Date(res.date) > now);
                    
                    const sortedToday = today.sort((a, b) => {
                      // Spojení data a času pro obě položky
                      const aDateTime = new Date(`${a.date}T${a.time}`);
                      const bDateTime = new Date(`${b.date}T${b.time}`);
                      
                      // Porovnání výsledných Date objektů
                      return aDateTime - bDateTime;
                    });

                    const sortedUpcoming = upcoming.sort((a, b) => {
                      const aDateTime = new Date(`${a.date}T${a.time}`)
                      const bDateTime = new Date(`${b.date}T${b.time}`)

                      return aDateTime - bDateTime
                    })
                    // Nastavení stavů
                    setHistoryBasicReservations(history);
                    setTodayBasicReservations(sortedToday);
                    setUpcomingBasicReservations(sortedUpcoming);
                } catch (err) {
                    console.log(err.response?.data?.message || "Chyba při načítání rezervací");
                }
            };
        
            fetchBasicReservation();
        }, [business, businessToken]);

        const fetchBasicReservation = async () => {
          if (!business?._id || !businessToken) return;
  
          try {
              const response = await axios.get(
                  `${process.env.REACT_APP_API_URL}/basic-reservation/list`,
                  {
                      params: { businessId: business._id },
                      headers: { Authorization: `Bearer ${businessToken}` },
                  }
              );
  
              const now = new Date();
  
              // Rozdělení rezervací podle data
              const history = response.data.reservation.filter(res => new Date(res.date) < now);
              const today = response.data.reservation.filter(res => new Date(res.date).toDateString() === now.toDateString());
              const upcoming = response.data.reservation.filter(res => new Date(res.date) > now);
              
              const sortedToday = today.sort((a, b) => {
                // Spojení data a času pro obě položky
                const aDateTime = new Date(`${a.date}T${a.time}`);
                const bDateTime = new Date(`${b.date}T${b.time}`);
                
                // Porovnání výsledných Date objektů
                return aDateTime - bDateTime;
              });

              const sortedUpcoming = upcoming.sort((a, b) => {
                const aDateTime = new Date(`${a.date}T${a.time}`)
                const bDateTime = new Date(`${b.date}T${b.time}`)

                return aDateTime - bDateTime
              })
              // Nastavení stavů
              setHistoryBasicReservations(history);
              setTodayBasicReservations(sortedToday);
              setUpcomingBasicReservations(sortedUpcoming);
          } catch (err) {
              console.log(err.response?.data?.message || "Chyba při načítání rezervací");
          }
      };

        const handleBasicReservationConfirm = async (id) => {
                try {
                    const response = await axios.put(`${process.env.REACT_APP_API_URL}/basic-reservation/confirm/${id}`,
                        { business: business._id },
                        {
                            headers: { Authorization: `Bearer ${businessToken}` },
                        }
                    );
                    
                    console.log(response.data.message || "hotovo")
                } catch (err) {
                    setBasicMessage((prevMessage) => ({
                      ...prevMessage,
                      [id]: err.response?.data?.message,
                    }))
                } finally {

                    fetchBasicReservation()

                }
            };
        
            const handleBasicReservationCancel = async (id) => {
                try {
                    const response = await axios.delete(`${process.env.REACT_APP_API_URL}/basic-reservation/cancel/${id}`, {
                        data: { business: business._id },
                        headers: { Authorization: `Bearer ${businessToken}` },
                    });
                    
                    setBasicMessage((prevMessage) => ({
                      ...prevMessage,
                      [id]: response?.data?.message,
                    }))
                } catch (err) {
                  setBasicMessage((prevMessage) => ({
                    ...prevMessage,
                    [id]: err.response?.data?.message,
                  }))
                }finally {
                    setTimeout(() => {
                      fetchBasicReservation()
                    }, 2000)
                    

                }
            };

          // fetch Adminpublicbusiness
          const [adminPublicData, setAdminPublicData] = useState(null);

          const fetchAdminPublicBusiness = useCallback(async (businessId) => {
            if (!businessId) return;
            try {
              const response = await axios.get(`${process.env.REACT_APP_API_URL}/business/admin-profile/public/${businessId}`)
              setAdminPublicData(response.data)
            } catch (err) {
              console.error(err.response?.data?.message || "Chyba při načítání veřejných dat firmy");
            }
          }, [])



  return (
    <AuthContext.Provider value={{
      adminPublicData,
      fetchReservationList,
      fetchBasicReservation,
      quest,
      isQuestAuthenticated,
      handleHotelReservationCancel,
      handleHotelReservationConfirm,
      hotelMessage, 
      upcomingBasicReservations, 
      basicMessage, 
      handleBasicReservationConfirm,
      handleBasicReservationCancel,
      todayBasicReservations, 
      profileWorkHours, 
      historyBasicReservations, 
      historyHotelReservations, 
      upcomingHotelReservations, 
      user, 
      userToken, 
      login, 
      logout, 
      business, 
      businessToken, 
      businessLogin, 
      businessLogout, 
      reservation,
      businessAdminToken,
      fetchBusinessAdmin,
      adminBusiness,
      fetchBusiness,
      todayReservation,
      futureReservation,
      historyReservation,
      fetchAdminPublicBusiness
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };